import React from 'react';
import css from './FileUpload.module.css';

export const IconCheck = () => (
  <svg
    className={css.iconCheck}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6635 3.02644C17.0631 3.25479 17.2019 3.76383 16.9735 4.16343L10.2707 15.8934C9.77035 16.769 8.55357 16.8846 7.89726 16.1189L3.11729 10.5423C2.81777 10.1929 2.85824 9.66678 3.20768 9.36727C3.55712 9.06775 4.0832 9.10822 4.38272 9.45765L8.9703 14.8098L15.5265 3.33653C15.7548 2.93693 16.2639 2.7981 16.6635 3.02644Z"
      fill="currentColor"
    />
  </svg>
);
